import Subject from "../cse4sub/Subject";
import React from 'react'
//import csm from '../assets/ASH501mid21.pdf'
import cse from '../assets/ASH501end21.pdf'
import csm from '../assets/ash501mid21.pdf'
export default function M_4() {
  return (
    <div>
       <Subject title="Mathematics_4(ASH501)" sub="Maths-4" syllabus="#"mid="Q. Paper"
    book1="S.S.Sastry, Introductory methods of numerical analysis, PHI, 4th Edition, 2005" 
    book2="E. Kreyszig, Advanced Engineering Mathematics, 9th Edition, John Wiley & Sons 2006."
    book1Link="https://www.pdfdrive.com/download.pdf?id=148704487&h=787c16750556f9786070b93606766122&u=cache&ext=pdf" 
    book2Link="https://www.pdfdrive.com/download.pdf?id=18720755&h=ba038e61b62f4e5e9702e7d290b4c219&u=cache&ext=pdf" 
    int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}